import { MessageSquare, Lightbulb, Film, Sparkles } from "lucide-react";

const steps = [
  {
    icon: MessageSquare,
    number: "01",
    title: "Erstgespräch",
    description: "Ziele, Botschaft und Zielgruppe verstehen.",
  },
  {
    icon: Lightbulb,
    number: "02",
    title: "Konzept & Story",
    description: "Entwicklung von Dramaturgie, Text, Bildsprache und Struktur.",
  },
  {
    icon: Film,
    number: "03",
    title: "Produktion",
    description: "Klassisch gedreht, KI-generiert oder als Hybrid – je nach Projekt.",
  },
  {
    icon: Sparkles,
    number: "04",
    title: "Feinschnitt & Ausspielung",
    description: "Fertige Filme in Formaten für Website, Reels, Ads & Kampagnen.",
  },
];

const Process = () => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-background via-background to-background">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-normal mb-4 tracking-tight">
            So Arbeiten Wir
          </h2>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12">
            {steps.map((step, index) => (
              <div
                key={index}
                className="relative animate-fade-in group hover:scale-105 transition-all duration-300 p-4 rounded-lg hover:bg-accent/5"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="flex gap-6">
                  {/* Icon & Number */}
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 rounded-full bg-accent/10 border-2 border-accent flex items-center justify-center mb-2 transition-all duration-300 group-hover:scale-110 group-hover:bg-accent/20 group-hover:border-accent/80 group-hover:shadow-lg group-hover:shadow-accent/30">
                      <step.icon className="w-8 h-8 text-accent transition-transform duration-300 group-hover:rotate-12" />
                    </div>
                    <div className="text-center">
                      <span className="text-sm font-bold text-accent">{step.number}</span>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex-1 pt-2">
                    <h3 className="text-2xl font-normal mb-3 tracking-tight">{step.title}</h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>

                {/* Connecting Line */}
                {index < steps.length - 1 && index % 2 === 0 && (
                  <div className="hidden md:block absolute top-8 -right-6 w-12 h-0.5 bg-accent/30"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
